import { render, staticRenderFns } from "./KykInfo.vue?vue&type=template&id=defab8e4"
import script from "./KykInfo.vue?vue&type=script&lang=js"
export * from "./KykInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports